module.exports = __webpack_public_path__ + "static/img/cart-nulll.e537a6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cart-nulll.png
// module id = jYnf
// module chunks = 1